import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { withRouter, Link as RouterLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'

import { getContentRecord, fetchContentRecord, getContentIndex, fetchContentIndex } from 'alpha-js'
import { getBusinessInfo } from 'alpha-js'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'

import useMediaQuery from '@material-ui/core/useMediaQuery'

import Markdown from '../ui/Markdown'

const styles = theme => ({
  root: {
//    backgroundColor: '#eee'
  },
  linkText: {
  },
  container: {
//    padding: theme.spacing.unit * 4,
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
  textBox: {
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left'
    }
  }
});

const PageMenuItemCard = ({ classes, theme, body, images }) => {

  let imageUrl = null
  if (images && images !== undefined && images.length > 0) {
    imageUrl = images[0].image_url
    if (imageUrl.startsWith("/"))
      imageUrl = "http://178.128.86.10:8000" + imageUrl
  }

  return (
  <>
    { imageUrl &&
      <Box mb={4}>
        <img src={imageUrl} className={classes.imageCenter} />
      </Box>
    }
    { body &&
      <Box>
        <Markdown source={ body } />
      </Box>
    }
  </>
  )
}

const FooterSection = ({ classes, theme, history, business, component, body, images, hero, items }) => {

  let imageUrl = null
  if (images && images !== undefined && images.length > 0) {
    imageUrl = images[0].image_url
    if (imageUrl.startsWith("/"))
      imageUrl = "http://178.128.86.10:8000" + imageUrl
  }

  return (
  <Box>
    { imageUrl &&
      <Box mb={4}>
        <img src={imageUrl} className={classes.imageCenter} />
      </Box>
    }
    { body &&
      <Box className={classes.textBox}>
        <Markdown source={ body } />
      </Box>
    }
  </Box>
  )
}

const Footer = ({ classes, theme, history, business, footerPage, fetchFooterPage, pageList, fetchPageList }) => {

  useEffect(() => {
    fetchFooterPage()
    fetchPageList()
  }, [])
  
  let sections = []
  if (footerPage.lastFetched && footerPage.data.sections !== undefined)
    sections = footerPage.data.sections
    
  if (sections.length <= 0)
    return (<></>)
      
  return (
    <div className={classes.root}>
      <Container className={classes.container}>
      <Grid container>
      { sections.map((section) => (
        <Grid item xs={12} sm={4} lg={3}>
          <FooterSection classes={classes} theme={theme} history={history} business={business} {...section}
            /> 
        </Grid>
        )) 
      }
      </Grid>
      </Container>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return { 
    footerPage: getContentRecord(state, "page", "footer"),
    pageList: getContentIndex(state, 'page', 'default'),
    business: getBusinessInfo(state, '0').data,    
    }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
 
  return {
    fetchFooterPage: () => {
      dispatch(fetchContentRecord('page', 'footer'))
    },
    fetchPageList: (refresh=false) => {
      dispatch(fetchContentIndex('page', 'default', null, refresh))
    },
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Footer)
  )
)